export default __webpack_public_path__ + "static/rhapsody-ec4b87f8faef7b5b0ef6abf6f7b24866.png";